import { z } from 'zod'

export const createSchoolCafeteriaFormSchema = z.object({
  schoolId: z.string().min(1, 'Поле не может быть пустым'),
  cafeteriaId: z.string().min(1, 'Поле не может быть пустым'),
})
